/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { OperatorNodeDependencies } from './dependenciesOperatorNode.generated.js';
import { parseDependencies } from './dependenciesParse.generated.js';
import { simplifyDependencies } from './dependenciesSimplify.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSymbolicEqual } from '../../factoriesAny.js';
export var symbolicEqualDependencies = {
  OperatorNodeDependencies,
  parseDependencies,
  simplifyDependencies,
  typedDependencies,
  createSymbolicEqual
};